import { render, staticRenderFns } from "./widget-secondary.vue?vue&type=template&id=cc72f6f8&scoped=true"
import script from "./widget-secondary.vue?vue&type=script&lang=ts"
export * from "./widget-secondary.vue?vue&type=script&lang=ts"
import style0 from "./widget-secondary.vue?vue&type=style&index=0&id=cc72f6f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72f6f8",
  null
  
)

export default component.exports